export const FILE_MAX_SIZE_LOGIN_BACKGROUND = 2 // mb

export const FILE_MAX_SIZE_POST = 10 // mb

export const FILE_MAX_SIZE = 300 // mb

export const FILE_MIN_SIZE = 1

export const FILE_SIZE_ROUND_PRECISION = 0.001

export const FILE_UPLOAD_CHUNK_SIZE = 3

export const FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME = {
  created: 'created',
  filename: 'filename',
  size: 'size',
  usersAccess: 'users_access',
}

export const FILE_USER_ACCESS_DENY = 'deny'

export const FILE_UPLOAD_API_ERROR_TRANSLATION_KEY = {
  The_submitted_file_is_empty: 'Error.SubmittedFileIsEmptyKey',
}

export const FILE_TITLE_ORDERING_NAME = 'name'

export const FILE_USER_ACCESS_PRIVATE = 'deny'
